import { Component, ElementRef, OnInit, Input, ViewChild, Output, AfterViewInit, EventEmitter, ViewEncapsulation, Renderer2, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { State, CompositeFilterDescriptor, filterBy } from '@progress/kendo-data-query';
import { DispatchesService } from '@app/cp/shared/services/dispatches.service';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { BaseGridEditFormLinesComponent } from '@app/cp/shared/base-components/base-grid-edit-formlines.component';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { KudosAndOpportunityBus } from '@app/cp/shared/models/KudosAndOpportunityBus';
import { SItem } from '@app/cp/shared/models/SItem';
import { GItem } from '../../shared/models/GItem';
import { DateFunctions } from '../../shared/static/date-functions';
import { CommonFunctions } from '../../shared/static/common-functions';
import { Subscription } from 'rxjs';
import { PersonSel } from '@app/cp/shared/models/PersonSelBus';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'kudos-opportunity',
    templateUrl: './kudos-opportunity.component.html',
    styleUrls: ['./kudos-opportunity.component.scss']
})
export class KudosAndOpportunityComponent extends BaseGridEditFormLinesComponent<KudosAndOpportunityBus, null, DispatchesService> implements OnInit, OnDestroy {

    @Input() canEditOthersNotes: boolean = false;
    @Input() mode: number = 0; //0-Both, 1-Kudos, 2-Opportunity
    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: DispatchesService, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;
        this.className = "KudosAndOpportunityBus";
        this.appCode = "KudosAndOpportunityNotes";
        this.appName = "Kudos And Opportunities";
        //necessary for grid displays that dont search
        this.disableCpSearchDialog();
    }
    public static virtualizationSettings = { itemHeight: 30, pageSize: 100 };
    private subs_featureFlagSet: Subscription; //place as class variable
    featureFlagSet = {};
    override ngOnInit(): void {
        super.ngOnInit();
        this.subs_featureFlagSet = this.featureFlagService.featureFlagSets.subscribe((data: any) => {
            this.featureFlagSet = data;
            this.usePrimeNg = this.featureFlagSet['use-primeng-inputs'];
        });
    }

    override ngOnDestroy(): void {
        super.ngOnDestroy();
        CommonFunctions.unsubscribe(this.subs_featureFlagSet); //place in ngOnDestroy
    }
    recordTypes: GItem[] = [
        { value: "Kudos", description: "Kudos", reference: null, category: null },
        { value: "Opportunity", description: "Opportunity", reference: null, category: null },
    ];
    createForm() {
        this.editForm = new UntypedFormGroup({
            'id': new UntypedFormControl(),
            'referenceId': new UntypedFormControl(),
            'comments': new UntypedFormControl(),
            'categoryId': new UntypedFormControl(),
            'categoryName': new UntypedFormControl(),
            'person': new UntypedFormControl(),
            'whoEnteredPerson': new UntypedFormControl(),
            'personId': new UntypedFormControl(),
            'recordType': new UntypedFormControl(),
            'dateOccurred': new UntypedFormControl(),
            'insertDt': new UntypedFormControl(),
            'insertUserId': new UntypedFormControl(),
            'updateDt': new UntypedFormControl(),
            'updateUserId': new UntypedFormControl(),
            'dispatchNotes': new UntypedFormControl(),
            'visibleToCustomer': new UntypedFormControl(),
            'highlight': new UntypedFormControl(),

        });
    }
    setForm() {
        this.editForm.patchValue({
            id: this.selectedData.id,
            referenceId: this.selectedData.referenceId,
            comments: this.selectedData.comments,
            categoryId: this.selectedData.categoryId,
            categoryName: this.selectedData.categoryName,
            person: this.selectedData.person,
            whoEnteredPerson: this.selectedData.whoEnteredPerson,
            personId: this.selectedData.personId,
            recordType: this.selectedData.recordType,
            dateOccurred: this.selectedData.dateOccurred,
            insertDt: this.selectedData.insertDt,
            insertUserId: this.selectedData.insertUserId,
            updateDt: this.selectedData.updateDt,
            updateUserId: this.selectedData.updateUserId

        });
    }
    get dispatchAssignedPersons(): PersonSel[] {
        return this.AppMode === 1 && CommonFunctions.hasArrayElementValue(this.assignedPersonNames) ? this.assignedPersonNames : this.referenceData.personsSel;
    }
    maxDateOccurred: Date = DateFunctions.getDateNow();
    subs_assignedPersonNames: Subscription;
    assignedPersonNames: PersonSel[];
    protected parentIdChanged() {
        CommonFunctions.unsubscribe(this.subs_assignedPersonNames);
        this.subs_assignedPersonNames = this.svc_data.getDispatchAssignmentNames(this._parentId).subscribe((info: BaseMessageInfo) => {
            if (!info.saveError) {
                let arr: PersonSel[] = [];
                for (let i = 0; i < info.primaryReturn.length; i++) {
                    let dataObj: PersonSel = new PersonSel(info.primaryReturn[i]);
                    dataObj.isActive = true;
                    arr.push(dataObj);
                }
                this.assignedPersonNames = arr; //info.primaryReturn;
            }
        });
    }
    usePrimeNg: boolean;

    afterAddNewData() {
        this.selectedData.recordType = "Kudos";
    }
    setFromReferenceData(data: KudosAndOpportunityBus) {
        data.person = this.personName(data.personId);
        if (CommonFunctions.hasGuidValue(data.insertUserId)) {
            data.whoEnteredPerson = this.personFromUserId(data.insertUserId).description;
        }
        return data;
    }
    protected getChangedObject(dataObj: KudosAndOpportunityBus) {
        let busObj: KudosAndOpportunityBus = new KudosAndOpportunityBus(dataObj);
        busObj.setBeforeSave();
        return busObj;
    }
    protected save(dataObj: KudosAndOpportunityBus) {

        let busObj: KudosAndOpportunityBus = this.getChangedObject(dataObj);
        busObj.setCommon(this.globals.userId, DateFunctions.getDateNow(), this.globals.companyId, this.globals.personId);
        busObj.setParentId(this._parentId);
        busObj.referenceId = this._parentId;
        busObj.dispatchId = this._parentId;
        //code for id

        this.svc_data.saveKudosAndOpportunityBus(busObj).subscribe((data: BaseMessageInfo) => {
            if (data != null) {
                busObj.id = data.primaryId;
                this.saveSuccess(busObj);
                busObj.isAdded = false;
            }
            else {
                this.saveError(dataObj, "Error Saving");
            }
        });
    }

    deleteIndividual(data: KudosAndOpportunityBus) {
        if (data.hasId) {
            if (data.recordType == "Kudos") {
                this.svc_data.deleteDispatchKudos(data.id).subscribe((dataObj: BaseMessageInfo) => {
                    if (!dataObj.saveError) {
                        this.deleteSuccess(data);
                        this.removeLocal(data);
                    }
                    else {
                        this.deleteError(data, dataObj.message);
                    }
                });
            }
            else {
                this.svc_data.deleteError(data.id).subscribe((dataObj: BaseMessageInfo) => {
                    if (!dataObj.saveError) {
                        this.deleteSuccess(data);
                        this.removeLocal(data);
                    }
                    else {
                        this.deleteError(data, dataObj.message);
                    }
                });
            }
        }
        else {
            this.closeEditor();
        }
    }
    get canEditNote(): boolean {
        let can: boolean = false;

        if (this.canEdit && this.selectedData) {
            //if (this.selectedData.dispatchNotesPersonId != this.globals.personId && this.canEditOthersNotes) {
            can = true;
            //}
        }

        return can;
    }
    recordTypeCBOChanged(recordType: string) {
        this.editForm.patchValue({
            recordType: recordType
        });

    }
    get recordType(): string {
        let recType: string = "K";
        if (this.editForm && this.editForm.value && this.editForm.value.recordType === "Opportunity") {
            recType = "O";
        }
        return recType;
    }
    recordTypeChanged(code: string) {
        this.editForm.patchValue({
            recordType: code
        });
        this.appName = code;
    }
    get hasId(): boolean {
        let hasId: boolean = false;
        if (this.editForm && this.editForm.value && CommonFunctions.hasGuidValue(this.editForm.value.id)) {
            hasId = true;
        }
        return hasId;
    }
    get canSavePopup(): boolean {
        let canSave: boolean = false;
        if (this.hasEditForm) {
            canSave = CommonFunctions.hasGuidValue(this.editForm.value.categoryId)
                && CommonFunctions.hasStringValue(this.editForm.value.recordType)
                && DateFunctions.hasReasonableDateValue(this.editForm.value.dateOccurred)
                && this.isDirty;
        }
        return canSave;
    }
}

